import api from '../api';

async function checkEmail (email) {
  return await api()
    .get('/auth/check_email', {
      params: {
        token: localStorage.getItem('token'),
        email,
      },
    })
    .then((response) => {
      if (response.data.ok) {
        return response.data.payload.exists;
      } else {
        this.$noty.error('An Error occurred: ' + response.data.error);
      }
    });
}

async function fetchShowInvite (inviteCode) {
  return api()
    .get('/company/invitations/' + inviteCode + '/fetch', {
      params: { token: localStorage.getItem('token') },
    })
    .then(response => {
      if (response.data.ok) {
        return response.data.payload;
      }
    });
}

async function checkInvite () {
  return api()
    .get('/company/invitations/check', {
      params: { token: localStorage.getItem('token') },
    })
    .then(function (response) {
      if (response.data.ok) {
        return response.data.payload.invitations;
      } else {
        return false;
      }
    });
}

async function acceptInvitation (inviteId) {
  return api().post('/company/invitations/' + inviteId + '/accept', {}, {
    params: { token: localStorage.getItem('token') },
  })
    .then(function (response) {
      return response.data;
    });
}

async function sendInvitations (invites) {
  return api()
    .post(
      '/company/send_invites',
      {
        invites: JSON.stringify(invites),
      },
      {
        params: { token: localStorage.getItem('token') },
      })
    .then(function (response) {
      return response.data.ok;
    })
    .catch(function (error) {
      if (!error.response) {
        self.$noty.error('Network Error occurred: Please, try again later.');
      } else {
        self.$noty.error('An Error occurred: ' + error.response.data.error);
      }
    });
}

async function signIn (email, password) {
  return api()
    .post('/auth/sign_in', {
      email,
      password,
    }, {
      params: { token: localStorage.getItem('token') },
    })
    .then((response) => {
      if (response.data.ok) {
        return response.data.payload;
      } else {
        return false;
      }
    });
}
async function signUp (email, password, inviteCode) {
  return api().post('/auth/sign_up', {
    email: email,
    password: password,
    invite_code: inviteCode,
  }, {
    params: { token: localStorage.getItem('token') },
  })
    .then(function (response) {
      return response.data.payload;
    });
}

async function restorePassword (email) {
  return api().post('/auth/restore', {
    email,
  }, {
    params: { token: localStorage.getItem('token') },
  })
    .then(function (response) {
      return response.data.ok;
    })
    .catch(function (error) {
      if (!error.response) {
        self.$noty.error('Network Error occurred: Please, try again later.');
      } else {
        self.$noty.error('An Error occurred: ' + error.response.data.error);
      }
    });
}

async function setNewPassword (restoreCode, password) {
  return api().post('/auth/set_password_with_restore_code', {
    restore_code: restoreCode,
    password: password,
  }, {
    params: { token: localStorage.getItem('token') },
  })
    .then(function (response) {
      return response.data.payload && response.data.ok;
    });
}

async function checkRestoreCode (restoreCode) {
  return api().get('/auth/check_restore_code', {
    params: {
      token: localStorage.getItem('token'),
      code: restoreCode,
    },
  })
    .then(function (response) {
      return response.data.ok;
    });
}

async function createCompany (name, size) {
  return api().post('/company/create', {
    name,
    size,
  }, {
    params: { token: localStorage.getItem('token') },
  })
    .then(function (response) {
      return response.data.ok;
    });
}

export {
  checkEmail,
  fetchShowInvite,
  checkInvite,
  acceptInvitation,
  sendInvitations,
  signIn,
  signUp,
  restorePassword,
  setNewPassword,
  checkRestoreCode,
  createCompany,
};
